module.exports = __webpack_public_path__ + "img/Contactofondo.d137fe3c.jpg";